<template>
	<div class="bg-white px-3 index">
		<div class="add_tits" ref="titles">
			<el-form class="form-inlines u-f u-jsb" :inline="true">
				<el-form-item>
					 <el-date-picker
					    size="small"
						v-model="timerValue"
						type="daterange"
						value-format="yyyy-MM-dd"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期">
					</el-date-picker>
					<el-button type="primary" icon="el-icon-search" size="small" @click="begin" style="margin-left:10px">搜索</el-button>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
					</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="ibox-content">
			<el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
				<el-table-column prop="id" label="话题ID" show-overflow-tooltip width="80"></el-table-column>
				<el-table-column prop="create_time" label="添加时间" width="180" show-overflow-tooltip></el-table-column>
				<el-table-column prop="title" label="标题" show-overflow-tooltip></el-table-column>
				<el-table-column prop="content" label="图片">
					<template slot-scope="scope">
						<div class="u-f u-wrap">
							<div>
								<img :src="scope.row.titlepic" alt="" width="50" class="tablimg">
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="desc" label="描述" show-overflow-tooltip></el-table-column>
				<el-table-column prop="post_count" label="发帖量" width="80" show-overflow-tooltip ></el-table-column>
				<el-table-column prop="follow" label="关注量" width="80" show-overflow-tooltip ></el-table-column>
				<el-table-column prop="view_count" label="热度" width="80" show-overflow-tooltip ></el-table-column>
				<el-table-column prop="pv" label="总PV" width="80" show-overflow-tooltip ></el-table-column>
				<el-table-column prop="uv" label="总UV" width="80" show-overflow-tooltip ></el-table-column>
				<el-table-column label="操作" width="300" align="center" fixed="right">
					<template slot-scope="scope">
						<el-button size="mini" type="info" v-if="scope.row.is_top!=1" plain
							@click="handle_top(scope.row,1)">置顶</el-button>
						<el-button size="mini" type="primary" v-else plain @click="handle_top(scope.row,0)">
							取消置顶</el-button>
						<el-button size="mini" type="primary" @click="handleEdit(scope.row,scope.$index)">编辑</el-button>
						<el-button size="mini" type="primary" @click="handleinfo(scope.row,scope.$index)">详情</el-button>
						<el-button size="mini" type="danger" @click="handleDelet(scope.row,scope.$index)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="u-f u-ac u-jsb ft_mr">
				<div></div>
				<div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[10]" :page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper" :total="count">
					</el-pagination>
				</div>
			</div>
		</div>

		<!--  -->
		<el-dialog title="广场设置" :visible.sync="dialogVisible" center top="60px" width="70%" class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px"
					class="demo-ruleForm forms-lines">
					<el-form-item label="标题" prop='title'>
						<el-input v-model="ruleForm.title" placeholder="请输入关键词" size="small" class="zwidth"></el-input>
					</el-form-item>
					<el-form-item label="描述" prop='desc'>
						<el-input v-model="ruleForm.desc" type="textarea" :rows="4" placeholder="请输入关键词" size="small"
							class="zwidth"></el-input>
					</el-form-item>
					<el-form-item label="图片" required>
						<el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
							:headers="{ 'token':$store.state.user.token }" :data="{ image_class_id:'2',file_type:'1', }"
							:file-list="ruleForm.lb_mapList" :on-success="uploadSuccess" :limit="1"
							:on-remove="uploadRmove" list-type="picture-card">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
				</el-form>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="submit('ruleForm')" :disabled='subloading' size="small" type="primary"
					:loading="subloading">提 交</el-button>
				<el-button @click="dialogVisible = false" size="small">取 消</el-button>
			</span>
		</el-dialog>

		<el-dialog title="详情" :visible.sync="dialoged" center top="60px" width="70%" class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<square ref="squares" :key="company"></square>
			</div>
			<el-divider></el-divider>
		</el-dialog>

	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import square from "./components/squarecopy.vue";
	export default {
		components: {
			square
		},
		data() {
			return {
				loading: false,
				tableData: [],
				count: 0,
				currentPage: 1,
				pagesize: 10,
				height: null,
				// 
				dialogVisible: false,
				subloading: false,
				mapListed: [],
				eid: 0,
				ruleForm: {
					title: '',
					desc: '',
					lb_mapList: [],
				},
				rule: {
					title: [{
						required: true,
						message: '请填写标题',
						trigger: 'blur'
					}],
					desc: [{
						required: true,
						message: '请填写描述',
						trigger: 'blur'
					}],
				},
				// 
				dialoged: false,
				company: 1,
				timerValue:''
			}
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		mounted() {
			this.getHeight()
			this.begin()
		},
		methods: {
			getHeight() {
				let that = this
				var titles = that.$refs.titles.offsetHeight
				that.height = window.innerHeight - titles - 200 + 'px'
				window.onresize = () => {
					var titles = that.$refs.titles.offsetHeight
					that.height = window.innerHeight - titles - 200 + 'px'
				}
			},
			// 搜索
			begin() {
				let that = this
				that.currentPage = 1
				that.pagesize = 10
				that.search()
			},
			search() {
				let that = this
				that.loading = true
				axios.get(`admin/topicclass/7/topic/${that.currentPage}?manager_id=${this.user.username=='admin'?'':this.user.id}&role_id=${this.user.role_id}&start=${this.timerValue?this.timerValue[0]:''}&end=${this.timerValue?this.timerValue[1]:''}`, {
						token: true,
					})
					.then(response => {
						that.loading = false
						that.tableData = response.data.data.list[1]
						that.count = response.data.data.list[0]
					})
					.catch(error => {})
			},
			handleSizeChange(val) {
				let that = this
				that.pagesize = val;
				that.search()
			},
			handleCurrentChange(val) {
				let that = this
				that.currentPage = val;
				that.search()
			},
			handleAdd() {
				let that = this
				this.eid = 0
				that.dialogVisible = true
				that.cancel()
			},
			handleinfo(row, index) {
				this.dialoged = true
				this.company += 1
				this.$nextTick(() => {
					this.$refs.squares.gcid = row.id
					this.$refs.squares.lb_value = 7
					this.$refs.squares.begin()

				})
			},
			cancel() {
				let that = this
				that.ruleForm.title = ''
				that.ruleForm.desc = ''
				that.ruleForm.lb_mapList = []
				that.mapListed = []
			},
			handleEdit(row, index) {
				let that = this
				that.cancel()
				that.dialogVisible = true
				this.eid = row.id
				that.ruleForm.title = row.title
				that.ruleForm.desc = row.desc
				that.ruleForm.lb_mapList = [{
					url: row.titlepic
				}]
				that.mapListed = [{
					url: row.titlepic
				}]
			},
			handle_top(row, val) {
				this.loading = true
				axios
					.post("/admin/pc/topicclass/edit_topic", {
						id: row.id,
						is_top: val
					}, {
						token: true
					})
					.then(response => {
						if (response.data.code == '200') {
							this.$message({
								type: 'success',
								message: '操作成功!'
							});
							this.search()
						} else {
							this.$message.error(response.data.message);
						}
						this.loading = false
					})
					.catch(error => {})
			},
			submit(formName) {
				let that = this
				that.$refs[formName].validate((valid) => {
					if (valid) {
						if (that.mapListed.length < 1) return that.$message.error('请上传封面');
						var picurl = that.mapListed[0].url
						if (this.eid && this.eid > 0) {
							var urls = "/admin/updatetopic"
						} else {
							var urls = "/admin/addtopic"
						}
						that.subloading = true
						axios.post(`${urls}`, {
								id: this.eid,
								titlepic: picurl,
								desc: this.ruleForm.desc,
								title: this.ruleForm.title,
								// topic_id: 7,
								topic_class_id: 7,
								manager_id: this.user.id,
								user_id: this.user.user_id
							}, {
								token: true
							})
							.then(response => {
								that.subloading = false
								if (response.data.code == '200') {
									that.dialogVisible = false
									that.search()
								} else {
									that.$message.error(response.data.msg);
								}
							})
							.catch(error => {
								that.subloading = true
							})
					} else {
						this.$alert("信息遗漏未填")
						return false;
					}
				});
			},
			handleDelet(row, index) {
				let that = this
				that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					axios
						.post("/admin/deltopic", {
							id: row.id
						}, {
							token: true
						})
						.then(response => {
							if (response.data.code == '200') {
								that.$message({
									type: 'success',
									message: '删除成功!'
								});
								that.search()
							} else {
								that.$message.error(response.data.message);
							}
						})
						.catch(error => {})

				}).catch(() => {
					that.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			// 
			uploadSuccess(response, file, fileList) {
				let that = this
				if (response.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1)
								}
							});
						}
					})
					that.$alert(response.msg)
					return;
				}
				that.$message({
					message: '上传成功',
					type: 'success'
				});
				that.mapListed.push(response.data)
			},
			uploadRmove(file, fileList) {
				this.mapListed = []
			},
		},
	}
</script>

<style>

</style>